"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@emotion/core");
const lodash_1 = require("lodash");
const components_1 = require("@/components");
const constants_1 = __importStar(require("@/constants"));
const styles_1 = __importDefault(require("./styles"));
const styles_scss_1 = __importDefault(require("./styles.scss"));
const PaywallBanner = ({ sections, setActiveStep, setExpandedSection, }) => (core_1.jsx("div", { className: styles_scss_1.default.paywallBanner },
    core_1.jsx("button", { className: styles_scss_1.default.closeBtn, css: styles_1.default.layoutCloseBtn(constants_1.Images.greyClose), onClick: () => {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            if (lodash_1.isEmpty(sections) || lodash_1.isEmpty((_b = (_a = sections[0]) === null || _a === void 0 ? void 0 : _a.entities) === null || _b === void 0 ? void 0 : _b.videos))
                return;
            setActiveStep({
                step: (_d = (_c = sections[0]) === null || _c === void 0 ? void 0 : _c.entities) === null || _d === void 0 ? void 0 : _d.videos[(_f = (_e = sections[0]) === null || _e === void 0 ? void 0 : _e.contents[0]) === null || _f === void 0 ? void 0 : _f.id],
                sectionId: (_g = sections[0]) === null || _g === void 0 ? void 0 : _g.id,
            });
            setExpandedSection((_h = sections[0]) === null || _h === void 0 ? void 0 : _h.id);
        }, type: "button" }),
    core_1.jsx("div", { className: styles_scss_1.default.paywallBannerImageCont },
        core_1.jsx("img", { className: styles_scss_1.default.image, src: constants_1.Images.undrawCompleting, alt: "banner" })),
    core_1.jsx("div", { className: styles_scss_1.default.stepBannerDescCont },
        core_1.jsx("h2", null, constants_1.default.paywall.banner.keepUp),
        core_1.jsx("p", null,
            constants_1.default.paywall.banner.toUnlock,
            " "),
        core_1.jsx(components_1.Link, { to: constants_1.Routes.PaywallSessions },
            core_1.jsx(components_1.Button, { className: styles_scss_1.default.paywallBannerButton, title: constants_1.default.paywall.banner.continue, ariaLabel: constants_1.default.paywall.banner.continue })))));
exports.default = PaywallBanner;
